// Must match STATISTICS_MAX_PERIOD_DAYS on the backend (clickhouse-statistics.service.ts)
export const STATISTICS_MAX_PERIOD_DAYS = 400;
